import { useState, useContext } from 'react';
import { TextButton, Typography, Form, visuallyHidden } from 'bonfire-kindling';
import { TaxonomyCodePicker } from 'components';
import { useTranslation } from 'react-i18next';
import axios from 'helpers/axios';
import WelcomeFooter from '../WelcomeFooter';
import { ToastContext } from 'contexts';
import { VENDORS_ME_TAXONOMYCODES } from 'constants/apis';

const PAPER_MAX_WIDTH = '1000px';

const Welcome3 = ({ values, decrementIndex, onSubmit: _onSubmit, onChange: _onChange }) => {
  const { t } = useTranslation();
  const toastContext = useContext(ToastContext);

  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const onSubmit = async () => {
    const payload = values.taxonomyCodes.map(code => code.taxonomyCodeID);
    setIsSaving(true);
    try {
      await axios.put(VENDORS_ME_TAXONOMYCODES, payload);
      _onSubmit({ taxonomyCodes: values.taxonomyCodes });
      toastContext.triggerToast({ variant: 'success' });
    } catch (err) {
      toastContext.triggerToast({});
      setIsSaving(false);
    }
  };

  const onChange = updateFunction => {
    _onChange({ taxonomyCodes: updateFunction(values.taxonomyCodes) });
  };

  return (
    <Form onSubmit={onSubmit}>
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Typography component="h1" sx={visuallyHidden}>
            {t('welcome.commodity_codes.title')}
          </Typography>
          <Typography variant="h4" component="p" sx={{ mb: 3 }}>
            {t('welcome.commodity_codes.intro')}
          </Typography>
          <Typography variant="body2" component="p" sx={{ mb: 3 }}>
            {t('welcome.commodity_codes.reason')}
          </Typography>
          <Typography variant="body2" component="p" sx={{ mb: 3 }}>
            {t('welcome.commodity_codes.select_instructions')}
          </Typography>
          <TaxonomyCodePicker
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            selectedTaxonomyCodes={values.taxonomyCodes}
            setSelectedTaxonomyCodes={onChange}
            variant="loose"
          />
          <WelcomeFooter isStickyBar stickyWidth={PAPER_MAX_WIDTH}>
            <TextButton
              variant="text"
              sx={{ fontWeight: '600' }}
              onClick={() => decrementIndex()}
              label={`< ${t('components.back')}`}
            />
            <TextButton
              type="submit"
              variant="contained"
              color="primary"
              isBusy={isSaving}
              disabled={values.taxonomyCodes.length === 0}
              label={t('welcome.save_next')}
            />
          </WelcomeFooter>
        </form>
      )}
    </Form>
  );
};

export default Welcome3;
